import React, { useState, useEffect, useContext } from "react";
import { BarbershopContext } from "../../providers/useProvider";

import { useAuth } from "../../context/AuthContext";
import { Routes, Route, Outlet } from "react-router-dom";
import NavSideBar from "../../components/navSidebar/NavSideBar";
import useAutoLogout from "../../hooks/useAutoLogout";
import Header from "../../components/Header";
//import './home.css';
const Home = () => {
  const { user, logout } = useAuth();
  useAutoLogout(user.token, logout);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  useEffect(() => {
    setIsSidebarOpen(window.innerWidth < 992 ? false : true);
  }, []);
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  return (
    <>
      <Header toggleSidebar={toggleSidebar} isopen={isSidebarOpen} />
      <NavSideBar toggleSidebar={toggleSidebar} isOpen={isSidebarOpen} />
      <div className={`main-page ${isSidebarOpen ? "" : "closed"}`}>
        <Outlet />
      </div>
    </>
  );
};
export default Home;
